import * as React from "react";
import * as ReactAutocomplete from "react-autocomplete";
import * as formStyles from "source/app/presentation/Shared/Form/Form.css";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "../../../Link/Hyperlink";
import { TExtendedCSS, StyleClass, TCSS } from "../../../Styles/CSS";

export function FuzzySelect({
    width,
    items,
    label,
    onChangeHandler,
    selectedValue,
}: {
    width: string;
    items: string[];
    label?: string;
    onChangeHandler: (value: string) => void;
    selectedValue: string;
}) {
    const [value, setValue] = React.useState<string>("");
    const inputElem = React.useRef<ReactAutocomplete>(null);

    const autoCompleteItems = items.map((item, index) => ({
        id: index,
        label: item,
    }));

    React.useEffect(() => setValue(selectedValue), [selectedValue]);

    React.useEffect(() => {
        const availableItems = GetMatchingItems(value);
        const numAvailableItems = availableItems.length;

        if (numAvailableItems === 1) {
            const selectedItemLabel = availableItems[0].label;
            onChangeHandler(selectedItemLabel);
        }

        if (numAvailableItems == 0) {
            return;
        }
    }, [value]);

    const GetMatchingItems = (value: string) => {
        const availableItems = autoCompleteItems.filter(
            (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
        );

        return availableItems;
    };

    return (
        <div>
            <span
                className={formStyles.label}
                style={{ float: "left", top: "15px", position: "relative" }}
            >
                {label}
            </span>
            <ReactAutocomplete
                items={autoCompleteItems}
                ref={inputElem}
                shouldItemRender={(item, value) =>
                    item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
                }
                getItemValue={(item) => item.label}
                value={value}
                onChange={(e) => {
                    if (GetMatchingItems(e.target.value).length > 0) {
                        setValue(e.target.value);
                    }
                }}
                onSelect={(value) => setValue(value)}
                inputProps={{
                    style: formControlStyle,
                }}
                menuStyle={{
                    background: "transparent",
                    margin: "0px 7px",
                    minWidth: "auto",
                }}
                renderItem={(item, highlighted) => (
                    <div
                        key={item.id}
                        style={{
                            color: "white",
                            backgroundColor: highlighted
                                ? "darkgoldenrod"
                                : item.id % 2 == 0
                                ? "rgb(134, 133, 133)"
                                : "dimgray",
                            textAlign: "left",
                        }}
                    >
                        {item.label}
                    </div>
                )}
                wrapperStyle={{
                    width,
                    margin: "0 auto",
                    display: "inline-block",
                }}
            />
            <Hyperlink
                classes={StyleClass(`fuzzySelectClearIcon`, {
                    color: "dimgray",
                    fontSize: "11px",
                })}
                whenClicked={() => {
                    setValue("");
                    onChangeHandler("");
                    inputElem.current?.focus();
                }}
            >
                <Glyphicon icon={EGlyphicon["remove"]} />
            </Hyperlink>
        </div>
    );
}

const formControlStyle: TExtendedCSS = {
    margin: "0 0.25em",
    fontSize: "16px",
    color: "#b3b3b3",
    background: "transparent",
    display: "inline",
    padding: "6px 12px",
    lineHeight: "1.42857143",
    border: "0",
    outline: "0",
    borderRadius: "4px",
    borderBottom: "1px dotted darkgoldenrod",
    WebkitBoxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075)",
    boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075)",
    width: "100%",
};
